<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>野兽配置 注意：请保证名称唯一</span>

          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="sys_app_logoAction"
                accept="xlsx"
                :limit="1"
                :on-success="(res)=>{return importUploadSuccess(res)}"
                :headers="headers"
              >
                <el-button v-permisaction="['config:animalConfig:import']" :loading="loading" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
              </el-upload>
            </el-col>

            <el-col :span="1.5">
              <el-button
                v-permisaction="['config:animalConfig:export']"
                type="primary"
                icon="el-icon-download"
                size="mini"
                @click="exportData()"
              >导出</el-button>
            </el-col>

            <el-col :span="1.5">
              <el-button
                v-permisaction="['config:animalConfig:export']"
                type="primary"
                icon="el-icon-download"
                size="mini"
                @click="exportJsonData(0)"
              >导出JSON</el-button>
            </el-col>
            <el-col :span="1.5">
              <syncVersion v-permisaction="['config:animalConfig:export']" :params="params" :in-method="exportBeastJson" />
            </el-col>
            <el-col :span="1.5">
              <ClearCacheApply />
              <sync-data />
            </el-col>
          </el-row>
        </div>

        <el-table :data="formData" border stripe>
          <el-table-column prop="id" label="id" width="200px">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.id" placeholder="id" />
            </template>
          </el-table-column>
          <el-table-column prop="lang_key" label="名称(多语言KEY)">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.lang_key" placeholder="名称(多语言KEY)" />
            </template>
          </el-table-column>
          <el-table-column prop="desc" label="备注">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.remark" placeholder="备注" />
            </template>
          </el-table-column>
          <el-table-column prop="can_send" label="是否能赠送">
            <template v-slot:default="scope">
              <el-select v-model="scope.row.can_send" placeholder="请选择">
                <el-option
                  v-for="item in sendArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="iconId" label="皮肤ID">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.iconId" placeholder="皮肤ID" />
            </template>
          </el-table-column>
          <el-table-column prop="fee" label="手续费">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.fee.num" placeholder="手续费" />
            </template>
          </el-table-column>
          <el-table-column prop="ability" label="能力">
            <template v-slot:default="scope">
              <ability :value="scope.row.ability" />
            </template>
          </el-table-column>
          <el-table-column prop="show_type" label="显示方式">
            <template v-slot:default="scope">
              <el-select v-model="scope.row.show_type" placeholder="请选择">
                <el-option
                  v-for="item in showTypeArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot:default="scope">
              <el-button v-permisaction="['config:animalConfig:del']" type="danger" @click="del(scope.$index,scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button v-permisaction="['config:animalConfig:add']" type="primary" @click="add()">+</el-button>
        <el-button v-permisaction="['config:animalConfig:add']" type="primary" @click="onSubmit()">保存</el-button>
        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import {
  deleteAnimalCfg,
  exportAnimalCfg, exportBeastJson,
  getAnimalList,
  importAnimalCfg,
  updateAnimalCfg
} from '@/api/config/area-cfg'
import ability from '@/views/config/animal-config/components/ability.vue'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncVersion from '@/components/SyncVersion/index.vue'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'AnimalConfig',
  components: {
    SyncData,
    SyncVersion,
    ability,
    ClearCacheApply
  },
  data() {
    return {
      params: { status: 1 },
      loading: false,
      configVisibleArr: [{ visible: false }],
      rewardVisibleArr: [{ visible: false }],
      total: 0,
      sendArr: [{ label: '是', value: 1 }, { label: '否', value: 0 }],
      showTypeArr: [{ label: '蛋', value: 1 }, { label: '野兽', value: 2 }],
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      formData: [
        {
          'id': 0,
          'lang_key': '',
          'iconId': 0,
          can_send: 0,
          fee: {
            propsId: 65,
            num: 0
          }
        }
      ] }
  },
  created() {
    this.getTables()
    this.getAreaList()
  },
  methods: {
    exportBeastJson,
    onSubmit() {
      for (const i in this.formData) {
        const _data = this.formData[i]
        if (_data.lang_key === '') {
          this.msgError('名称不能为空')
          return
        }
        _data.lang_key = _data.lang_key.replace(/\s/g, '')
        if (isNaN(Number(this.formData[i].fee.num))) {
          this.msgError('手续费只能是数字')
          return
        }
        this.formData[i].fee.num *= 10000
      }
      const data = JSON.stringify(this.formData)
      console.log(data)
      updateAnimalCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.$store.dispatch('app/clearLocalStorage', { key: 'getAnimalAllList' })
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getAreaList() {
      // getAreaCfgAll().then(res => {
      //   if (res.code === 200) {
      //     this.areaData = res.data
      //   } else {
      //     this.msgError(res.msg)
      //   }
      // })
    },
    getTables() {
      getAnimalList(this.queryParams).then(res => {
        if (res.code === 200) {
          const data = res.data.list
          data.forEach((item, index) => {
            if (res.data.list[index].fee == null) {
              res.data.list[index].fee = {
                propsId: 65,
                num: 0
              }
            } else {
              res.data.list[index].fee.num /= 10000
            }
          })
          this.formData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.formData.push({
        'id': 0,
        'langKey': '',
        'iconId': 0,
        can_send: 0,
        fee: {
          propsId: 65,
          num: 0
        },
        show_type: 1,
        ability: []
      })
    },
    del(key, id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteAnimalCfg({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    exportData() {
      exportAnimalCfg().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importUploadSuccess(response) {
      this.loading = true
      this.$refs.upload.clearFiles()
      importAnimalCfg({ data: response.data.path }).then(res => {
        this.loading = false
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportJsonData(typ = 0) {
      exportBeastJson({ status: typ }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          // this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
